import React, { useEffect, useState } from 'react';

const DocxView: React.FC<{
    src: string;
    title: string;
    openLabel?: string;
    downloadLabel?: string;
    className?: string;
}> = ({
    src,
    title,
    // openLabel = 'Открыть .docx',
    downloadLabel = 'Скачать .docx',
    className,
}) => {
    const [html, setHtml] = useState<string>('');
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string>('');

    useEffect(() => {
        let isMounted = true;

        const load = async () => {
            setLoading(true);
            setError('');
            setHtml('');
            try {
                const res = await fetch(encodeURI(src), { cache: 'no-store' });
                if (!res.ok) throw new Error(`Не удалось загрузить документ (${res.status})`);
                const arrayBuffer = await res.arrayBuffer();
                // @ts-ignore
                const mod = await import(/* webpackChunkName: "mammoth-browser" */ 'mammoth/mammoth.browser');
                const mammoth: any = mod && mod.default ? mod.default : mod;
                const result = await mammoth.convertToHtml(
                    { arrayBuffer },
                    {
                        styleMap: [
                            "p[style-name='Normal'] => p",
                            "p[style-name='Heading 1'] => h2",
                            "p[style-name='Heading 2'] => h3",
                            "p[style-name='Heading 3'] => h4",
                            'u => span.underline',
                        ],
                        ignoreEmptyParagraphs: true,
                    },
                );
                if (!isMounted) return;
                setHtml(result.value || '');
            } catch (e: any) {
                if (!isMounted) return;
                setError(e?.message || 'Ошибка чтения документа');
            } finally {
                if (isMounted) setLoading(false);
            }
        };
        load();
        return () => {
            isMounted = false;
        };
    }, [src]);

    return (
        <div className={`docxView ${className || ''}`}>
            <div className="docxView__toolbar" aria-label="Управление документом">
                <div className="docxView__title" title={src}>
                    {title}
                </div>
                <div className="docxView__actions">
                    <a className="customersPage__btn customersPage__btn--ghost" href={encodeURI(src)} download>
                        {downloadLabel}
                    </a>
                    {/* <a className="customersPage__btn customersPage__btn--primary" href={encodeURI(src)} target="_blank" rel="noopener noreferrer">
                        {openLabel}
                    </a> */}
                </div>
            </div>

            {loading && (
                <div className="docxView__skeleton" aria-busy="true" aria-live="polite">
                    <div className="docxView__line" />
                    <div className="docxView__line" />
                    <div className="docxView__line" />
                    <div className="docxView__line docxView__line--short" />
                </div>
            )}

            {!loading && error && (
                <div className="docxView__fallback">
                    <p className="docxView__fallback_text">{error}. Вы можете скачать документ.</p>
                    <div className="docxView__fallback_actions">
                        {/* <a className="customersPage__btn customersPage__btn--primary" href={encodeURI(src)} target="_blank" rel="noopener noreferrer">
                            Открыть .docx
                        </a> */}
                        <a className="customersPage__btn customersPage__btn--ghost" href={encodeURI(src)} download>
                            Скачать .docx
                        </a>
                    </div>
                </div>
            )}

            {!loading && !error && <article className="docxView__content typeset" dangerouslySetInnerHTML={{ __html: html }} />}
        </div>
    );
};

export default DocxView;
